$(document).ready(function () {
    // Use the globally defined values (already populated via Liquid)
    var traficProductCode = window.ChatTrafficInfo?.traficProductCode || '';
    var traficProductImage = window.ChatTrafficInfo?.traficProductImage || '';

    var country = window.country || '';

    function getTrafficInfo() {
        let params = new URLSearchParams(window.location.search);

        // Default traffic
        let source = "direct";
        let medium = "none";
        let campaign = params.get("utm_campaign") || "none";

        // 1. Check UTM parameters
        if (params.get("utm_source")) {
            source = params.get("utm_source");
            medium = params.get("utm_medium") || "unknown";
        } 
        // 2. Detect Awin Affiliate traffic
        else if ((params.has("fo_s") && params.get("fo_s") === "awin") || params.has("aw_affid") || (params.get("cm_mmc") && params.get("cm_mmc").includes("AWIN"))) {
            source = "awin";
            medium = "affiliate";
            campaign = params.get("aw_sitename") || "awin_affiliate";
        }
        // 3. Detect Ad Platforms via IDs
        else if (params.has("gclid") || params.has("gbraid") || params.has("gad_source")) {
            source = "google";
            medium = "paid";
            campaign = "google_ads";
        } else if (params.has("fbclid")) {
            source = "facebook";
            medium = "paid";
            campaign = "facebook_ads";
        } else if (params.has("msclkid")) {
            source = "bing";
            medium = "paid";
            campaign = "microsoft_ads";
        }
        // 4. Detect email
        else if (params.has("_kx") || (params.get("utm_medium") && params.get("utm_medium") === "email")) {
            source = "klaviyo";
            medium = "email";
            campaign = campaign !== "none" ? campaign : "email_campaign";
        }
        // 5. Referrer check
        else if (document.referrer) {
            let ref = document.referrer.toLowerCase();
            if (ref.includes("google.")) {
                source = "google";
                medium = "organic";
            } else if (ref.includes("bing.")) {
                source = "bing";
                medium = "organic";
            } else if (ref.includes("yahoo.")) {
                source = "yahoo";
                medium = "organic";
            } else if (ref.includes("facebook.")) {
                source = "facebook";
                medium = "social";
            } else if (ref.includes("instagram.")) {
                source = "instagram";
                medium = "social";
            } else if (ref.includes("t.co") || ref.includes("twitter.")) {
                source = "twitter";
                medium = "social";
            } else if (ref.includes("whatsapp.")) {
                source = "whatsapp";
                medium = "social";
            } else {
                source = ref;
                medium = "referral";
            }
        }

        // Device detection
        let ua = navigator.userAgent.toLowerCase();
        let device = /mobile|android|iphone|ipad/i.test(ua) ? "mobile" : "desktop";

        // Browser detection
        let browser = "unknown";
        if (ua.includes("firefox")) browser = "firefox";
        else if (ua.includes("chrome") && !ua.includes("edg") && !ua.includes("opr")) browser = "chrome";
        else if (ua.includes("safari") && !ua.includes("chrome")) browser = "safari";
        else if (ua.includes("edg")) browser = "edge";
        else if (ua.includes("opr") || ua.includes("opera")) browser = "opera";

        // OS detection
        let os = "unknown";
        if (/windows nt/i.test(ua)) os = "windows";
        else if (/macintosh|mac os x/i.test(ua)) os = "macos";
        else if (/android/i.test(ua)) os = "android";
        else if (/iphone|ipad|ipod/i.test(ua)) os = "ios";
        else if (/linux/i.test(ua)) os = "linux";

        // Landing path
        let landingPath = window.location.pathname === "/" ? "home" : window.location.pathname;

        // Path type detection
        let pathType = "other";
        const path = window.location.pathname.toLowerCase();
        if (path === "/" || path === "") pathType = "home";
        else if (path.startsWith("/collections/")) pathType = "collection";
        else if (path.startsWith("/products/")) pathType = "product";
        else if (path.startsWith("/pages/")) pathType = "page";
        else if (path.startsWith("/blogs/")) {
            const blogSubpath = path.replace("/blogs/", "");
            pathType = blogSubpath.includes("/") ? "article" : "blog";
        }

        let trafficData = {
            source: source,
            medium: medium,
            campaign: campaign,
            device: device,
            browser: browser,
            os: os,
            pathType: pathType,
            country: country,
            landingPath: landingPath,
            traficProductCode: traficProductCode,
            traficProductImage: traficProductImage
        };

        sessionStorage.setItem("trafficInfo", JSON.stringify(trafficData));
        console.log("Traffic info stored:", trafficData);
    }

    // Only capture once per session
    if (!sessionStorage.getItem("trafficInfo")) {
        getTrafficInfo();
    }

    const $popup = $("#floatingAiAssistant");

    const CLOSE_KEY = "aiAssistantClosedCount";

    let closeCount = Number(sessionStorage.getItem(CLOSE_KEY)) || 0;
    if (closeCount < 2) {
        $popup.show();
        $popup.addClass("active");
    } else {
        $popup.hide();
        $popup.removeClass("active");
        return;
    }

    // Show popup with fade/slide animation
    setTimeout(() => {
        $popup.addClass("active");
    }, 500);

    // Close button click
    $popup.find(".ai-close").on("click", function () {
        $popup.removeClass("active");
        $popup.hide();

        closeCount++;
        sessionStorage.setItem(CLOSE_KEY, closeCount);
    });

    // Try AI button click
    $popup.find(".ai-btn").on("click", function (e) {
        e.preventDefault();

        let existingData = {};
        try {
            existingData = JSON.parse(sessionStorage.getItem("trafficInfo")) || {};
        } catch (error) {
            existingData = {};
        }

        if (!existingData.aiclicked) {
            existingData.aiclicked = true;
            sessionStorage.setItem("trafficInfo", JSON.stringify(existingData));
            console.log("✅ aiclicked added to trafficInfo:", existingData);
        } else {
            console.log("ℹ️ aiclicked already exists — skipping update:", existingData);
        }

        const targetUrl = $(this).attr("href");
        setTimeout(() => {
            window.location.href = targetUrl;
        }, 150);
    });
});
